import { IIntervalsFactResponse, IIntervalsInStore, IIntervalsPlanResponse } from "./types";

export const intervalsStoreUtils = {
  prepareIntervalsForStoring: (
    intervals: Partial<IIntervalsFactResponse> & Partial<IIntervalsPlanResponse>
  ): IIntervalsInStore => {
    const { approveds, ...rest } = intervals;

    const preparedApproveds = approveds?.map((el) => ({ ...el, interval_id: el.id }));

    const withApproveds = preparedApproveds ? { approveds: preparedApproveds } : {};

    return { ...rest, ...withApproveds };
  },
};
